export default __webpack_public_path__ + "static/media/category.918e8e42.svg";